import React, { useState, useRef, useEffect } from 'react'
import { Panel } from 'rsuite';
import { Loader } from 'rsuite';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useDispatch } from 'react-redux';

import { createTranscriptions, getRecordingUrl, getSentenceData } from '../../../redux/actions/caller';
import { toast } from '../ToastComponent/toast';

const AudioTranscript = ({ transcriptionSid, audioSrc, callType, recordingDetails, setHistories, id, callRecordingSid }) => {
    const [transcriptionSentences, setTranscriptionSentences] = useState([])
    const [expanded, setExpanded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isLoadingForCreating, setIsLoadingForCreating] = useState(false)
    const wordsRef = useRef(null);
    const dispatch = useDispatch()
    const [secureAudioUrl, setSecureAudioUrl] = useState('');
    const [isLoadingRecording, setIsLoadingRecording] = React.useState(false);

    useEffect(() => {
        const fetchAudio = async () => {
            if (!callRecordingSid) return;

            try {
                setIsLoadingRecording(true)
                const response = await dispatch(getRecordingUrl(callRecordingSid))
                const blobUrl = URL.createObjectURL(new Blob([response], { type: 'audio/mpeg' }))
                setSecureAudioUrl(blobUrl)
                setIsLoadingRecording(false)
            } catch (err) {
                setIsLoadingRecording(false)
                if (err) {
                    toast.show({
                        title: 'Danger',
                        description: 'Unable To Get Recording Details'
                    })
                }
            }
        };

        fetchAudio();
    }, [callRecordingSid]);


    const panelHeader = () => {
        return <h4 className='text-black p-2 fw-bold'>Transcription</h4>
    }

    const handleOnSelect = async (transcriptionSid, createTranscription) => {
        if (!transcriptionSid) {
            setTranscriptionSentences([])
            setExpanded(true)
            return
        }

        if (!expanded || createTranscription) {
            setIsLoading(true)
            await dispatch(getSentenceData(transcriptionSid))
                .then(res => {
                    setTranscriptionSentences(res?.sentences || [])
                    setIsLoading(false)
                    setExpanded(true)
                }).catch(err => {
                    setTranscriptionSentences([])
                    setIsLoading(false)
                    setExpanded(false)

                })
        } else {
            setTranscriptionSentences([])
            setExpanded(false)
        }
    }

    const onGetTranscriptionHandler = async () => {
        setIsLoadingForCreating(true)
        const result = await dispatch(createTranscriptions(recordingDetails?.callSid, recordingDetails?.callRecordingSid)).then((res) => res).catch(err => { if (err) { return null } })

        if (result?.transcriptionSid) {
            setTimeout(async () => {
                await handleOnSelect(result?.transcriptionSid, true)
                setIsLoadingForCreating(false)
            }, 5000)
        }
        setHistories(prevState => {
            return prevState?.map((history) => {
                if (history?.id === id) {
                    history.callTranscriptionSid = result?.transcriptionSid
                }
                return history
            })
        })
    }

    return (
        <div className='audio-transcription-component'>
            {isLoadingRecording ? (
                <Loader className="w-100 text-center" />
            ) : (
                secureAudioUrl && (
                    <AudioPlayer
                        autoPlayAfterSrcChange={false}
                        src={secureAudioUrl}
                    />
                )
            )}
            <Panel className={`transcription-panel mt-4 mb-4 p-3 h-auto no-scrollbar position-relative${isLoading ? ' loading' : ''}`} header={panelHeader()} collapsible bordered expanded={expanded} onSelect={() => { handleOnSelect(transcriptionSid, false) }}>
                {isLoading && <Loader center={true} size='sm' />}
                <div className={`transcription-content`} ref={wordsRef}>
                    {!isLoading && (transcriptionSentences.length ? transcriptionSentences?.map((sentence, i) => {
                        return (
                            <div className='d-flex align-items-center gap-5 mb-4'>
                                <h3 className='mb-0 text-black fw-bold transcription-channel'> {callType === "inbound" ? sentence?.media_channel === 1 ? 'Supplier' : 'Caller' : sentence?.media_channel === 2 ? 'Supplier' : 'Caller'} </h3>
                                <hr className={`${sentence?.media_channel === 2 ? 'vendor vertical-bar' : 'caller vertical-bar'}`} />
                                <h5 className='mb-0 text-black' key={i}>{sentence?.transcript}</h5>
                            </div>
                        )
                    }) : <h4 className='mb-0 text-black'>No Transcription available.</h4>)}
                    {transcriptionSentences?.length === 0 && recordingDetails?.callRecordingSid && <div className='mt-2'>
                        <button className='small_button_success' onClick={onGetTranscriptionHandler}>{isLoadingForCreating ? <div className='d-flex align-items-center justify-content-center'><Loader /></div> : 'Create Transcription'}</button>
                    </div>}
                </div>
            </Panel>
        </div>
    );
};

export default AudioTranscript
